import { Component, Inject } from '@angular/core';
import {
    MatSnackBarRef,
    MAT_SNACK_BAR_DATA,
} from '@angular/material/snack-bar';

@Component({
    selector: 'app-success-snack-bar',
    templateUrl: './success-snack-bar.component.html',
    host: {
        class: 'flex flex-row items-center',
    },
})
export class SuccessSnackBarComponent {
    constructor(
        public snackBarRef: MatSnackBarRef<SuccessSnackBarComponent>,
        @Inject(MAT_SNACK_BAR_DATA) public data: any
    ) {}
}
